import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { papi } from "@/lib/papi";

const PlatformAuthContext = createContext(null);

export function PlatformAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [status, setStatus] = useState("checking");

  const load = useCallback(async () => {
    if (!localStorage.getItem("pnc_platform_token")) { setStatus("guest"); return; }
    try {
      const { data } = await papi.get("/platform/me");
      setAdmin(data.admin);
      setStatus("authed");
    } catch { setStatus("guest"); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = useCallback((token, a) => {
    localStorage.setItem("pnc_platform_token", token);
    setAdmin(a);
    setStatus("authed");
  }, []);

  const logout = useCallback(async () => {
    try { await papi.post("/platform/logout"); } catch {}
    localStorage.removeItem("pnc_platform_token");
    setAdmin(null);
    setStatus("guest");
  }, []);

  return (
    <PlatformAuthContext.Provider value={{ admin, status, login, logout }}>
      {children}
    </PlatformAuthContext.Provider>
  );
}

export function usePlatformAuth() {
  return useContext(PlatformAuthContext);
}
